<script setup lang="ts">
import Rating from '../../shared/Rating.vue'

defineProps<{
  ratingAverage?: number,
  ratingQuantity?: string
}>()
</script>

<template>
  <Rating :quantity="ratingQuantity"
          :average="ratingAverage"
          average-postfix="/5 "
          :average-fraction-digits="1"
          :show-average="true"
          :is-recipe-rating="true"
          size="responsive"
          title="Bewertungen ansehen" />
  <a class="bx-recipe__rating-button"
     title="Rezept bewerten">
    Rezept bewerten
  </a>
</template>
